import {
  createAsyncThunk,
  createSlice
} from "@reduxjs/toolkit";

import AuthService from "../../services/auth.service";

/* LOGIN */

export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async (item, thunkAPI) => {

    try {

      const data =
        await AuthService.userLogin(item);

      return data;

    } catch (error) {

      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

/* REGISTER */

export const register = createAsyncThunk(
  "auth/register",
  async (item, thunkAPI) => {

    try {

      const data =
        await AuthService.register(item);

      return data;

    } catch (error) {

      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

/* VERIFY OTP */

export const verifyotp = createAsyncThunk(
  "auth/verifyotp",
  async (item, thunkAPI) => {

    try {

      const data =
        await AuthService.verifyotp(item);

      return data;

    } catch (error) {

      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

/* LOGOUT */

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {

    try {

      localStorage.removeItem("user");

      localStorage.removeItem(
        "accessToken"
      );

      localStorage.removeItem(
        "refreshToken"
      );

      return true;

    } catch (error) {

      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const forgotPasswords = createAsyncThunk("auth/forgotPasswords", async (item, thunkAPI) => {
  try {
    const data = await AuthService.forgotPassword(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const verifyOtpAndSetPassword = createAsyncThunk("auth/verifyOtpAndSetPassword", async (item, thunkAPI) => {
  try {
    const data = await AuthService.setPassword(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const getProfile =
  createAsyncThunk(
    "auth/getProfile",
    async (_, thunkApi) => {

      try {

        const response =
          await AuthService.getProfile();

        return response.data;

      } catch (error) {

        return thunkApi.rejectWithValue(
          error.response?.data?.message ||
          error.message
        );
      }
    }
  );

/* CHANGE PASSWORD */

export const changePassword =
  createAsyncThunk(
    "auth/changePassword",
    async (item, thunkApi) => {

      try {

        const response =
          await AuthService.changePassword(item);

        return response.data;

      } catch (error) {

        return thunkApi.rejectWithValue(
          error.response?.data?.message ||
          error.message
        );
      }
    }
  );

const initialState = {
  loading: false,
  error: "",

  user: AuthService.getUserDetails() || null,

  profile: null,

  registerData: null,

  otpVerified: false,

  forgotPasswordSuccess: false,

  passwordResetSuccess: false,

  passwordChanged: false,
};

const authSlice = createSlice({

  name: "auth",

  initialState,

  reducers: {},

  extraReducers: (builder) => {

    builder

      /* LOGIN */

      .addCase(userLogin.pending, (state) => {

        state.loading = true;

        state.error = "";
      })

      .addCase(userLogin.fulfilled,
        (state, action) => {

          state.loading = false;

          state.user = action.payload;
        }
      )

      .addCase(userLogin.rejected,
        (state, action) => {

          state.loading = false;

          state.error = action.payload;
        }
      )

      /* FORGOT PASSWORD */

      .addCase(forgotPasswords.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.forgotPasswordSuccess = false;
      })

      .addCase(forgotPasswords.fulfilled, (state) => {
        state.loading = false;
        state.forgotPasswordSuccess = true;
      })

      .addCase(forgotPasswords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* VERIFY OTP & SET PASSWORD */

      .addCase(verifyOtpAndSetPassword.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.passwordResetSuccess = false;
      })

      .addCase(verifyOtpAndSetPassword.fulfilled, (state) => {
        state.loading = false;
        state.passwordResetSuccess = true;
      })

      .addCase(verifyOtpAndSetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CHANGE PASSWORD */

      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.passwordChanged = false;
      })

      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
        state.passwordChanged = true;
      })

      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(register.pending,
        (state) => {

          state.loading = true;

          state.error = "";
        }
      )

      .addCase(register.fulfilled,
        (state, action) => {

          state.loading = false;

          state.registerData =
            action.payload;
        }
      )

      .addCase(register.rejected,
        (state, action) => {

          state.loading = false;

          state.error = action.payload;
        }
      )

      /* VERIFY OTP */

      .addCase(verifyotp.pending,
        (state) => {

          state.loading = true;

          state.error = "";
        }
      )

      .addCase(verifyotp.fulfilled,
        (state) => {

          state.loading = false;

          state.otpVerified = true;
        }
      )

      .addCase(verifyotp.rejected,
        (state, action) => {

          state.loading = false;

          state.error = action.payload;
        }
      )

      /* PROFILE */

      .addCase(getProfile.pending,
        (state) => {

          state.loading = true;

          state.error = "";
        }
      )

      .addCase(getProfile.fulfilled,
        (state, action) => {

          state.loading = false;

          state.profile = action.payload;
        }
      )

      .addCase(getProfile.rejected,
        (state, action) => {

          state.loading = false;

          state.error = action.payload;
        }
      )

      /* LOGOUT */

      .addCase(logout.fulfilled, (state) => {
        Object.assign(state, {
          ...initialState,
          user: null,
        });
      })

  },
});

export default authSlice.reducer;